import React, { useMemo } from "react";
import "twin.macro";

import { Permission, usePermissionsContext } from "src/shared/contexts";
import { useHardwareOrganizerAccess } from "src/shared/hooks";
import NotFound from "src/views/404";

import HackerInventory from "./hacker";
import OrganizerInventory from "./organizer";

const Inventory: React.FC = () => {
  const { hasPermissions } = usePermissionsContext();
  const isHardwareOrganizer = useHardwareOrganizerAccess();

  const hasHackerAccess = useMemo(
    () => hasPermissions([Permission.HACKER_EVENT_ACCESS]),
    [hasPermissions]
  );

  if (isHardwareOrganizer) {
    return <OrganizerInventory />;
  }

  if (hasHackerAccess) {
    return <HackerInventory />;
  }

  return <NotFound />;
};

export default Inventory;
